import Multiselect from 'multiselect-react-dropdown'
import React, { useEffect, useState } from 'react'
import { Typeahead } from 'react-bootstrap-typeahead'
import { courseSpecializationList, educationqualificationList, jobIndustryList, qualificationList, searchSkill } from '../../action/jobs'
import NumberFormat from 'react-number-format'
import { validateFunctionalForm } from '../../utils'
import ReactQuill from "react-quill"; // import ReactQuill
import "react-quill/dist/quill.snow.css"; // import styles

const StepTwo = ({ styles, detail, prevStep, onSubmit }) => {
    const [state, setState] = useState({
        work_exp_min: {
            name: "work_exp_min",
            value: detail ? detail.WORK_EXP_MIN : "",
            error: "",
            isRequired: true,
        },
        work_exp_max: {
            name: "work_exp_max",
            value: detail ? detail.WORK_EXP_MAX : "",
            error: "",
            isRequired: true,
        },

        keywords: {
            name: "keywords",
            value: detail ? detail.KEYWORDS : [],
            options: [],
            error: "",
            isRequired: true,
        },
        industry: {
            name: "industry",
            value: detail ? detail.INDUSTRY_ID : "",
            options: [],
            error: "",
            isRequired: true,
        },




        job_description: {
            name: "job_description",
            value: detail ? detail.JOB_DETAILS : "",
            options: [],
            error: "",
            isRequired: true,
        },

        work_exp_type: {
            name: "work_exp_type",
            value: (detail.WORK_EXP_MIN == '0' && detail.WORK_EXP_MAX != '0')
                ? 'BOTH'
                : (detail.WORK_EXP_MIN == '0' && detail.WORK_EXP_MAX == '0')
                    ? 'FRESHER'
                    : 'EXPERIENCED',
            error: "",
            isRequired: true,
        },
        gender: {
            name: "gender",
            value: detail ? detail.GENDER : "BOTH",
            error: "",
            isRequired: false,
        },
        age_min: {
            name: "age_min",
            value: detail ? detail.MIN_AGE : "",
            error: "",
            isRequired: false,
        },
        age_max: {
            name: "age_max",
            value: detail ? detail.MIN_AGE : "",
            error: "",
            isRequired: false,
        },
        selected_skills: detail ? detail.KEYWORDS : [],
        selected_qualification: {
            value: detail ? detail.QUALIFICATION_ID.map((data, index) => {
                return {
                    QUALIFICATION_ID: data.QUALIFICATION_ID,
                    QUALIFICATION_NAME: data.QUALIFICATION_NAME,
                    label: data.QUALIFICATION_NAME
                }
            }) : [], name: 'selected_qualification', error: "",
            isRequired: true
        },

        selected_education_qualification: detail
            ? detail.EDUCATION_QUALIFICATION_ID.map((data, index) => {
                return {
                    EDUCATION_QUALIFICATION_ID: data.EDUCATION_QUALIFICATION_ID,
                    COURSE_STREAM: data.COURSE_STREAM,
                    label: data.COURSE_STREAM
                }
            })
            : [],
        selected_course_specialization: detail
            ? detail.COURSE_SPECIALIZATION.map((data, index) => {
                return {
                    SPECIALIZATION_ID: data.SPECIALIZATION_ID,
                    SPECIALIZATION: data.SPECIALIZATION,
                    label: data.SPECIALIZATION
                }
            })
            : [],
        qualification_list: [],
        education_qualification_list: [],
        specialization_list: [],

        qualification_search_key: false,
        education_qualification_search_key: false,
        specialization_search_key: false
    })
    useEffect(() => {
        jobIndustryList()
            .then((res) => {
                if (res.status) {
                    setState((prevState) => ({
                        ...prevState,
                        ['industry']: {
                            ...prevState['industry'],
                            options: res.result
                        }
                    }));
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });
    }, [])
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
            }
        }));
    };

    const getEducationQualificationList = (list) => {
        educationqualificationList(list).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        EDUCATION_QUALIFICATION_ID: data.EDUCATION_QUALIFICATION_ID,
                        COURSE_STREAM: data.COURSE_STREAM,
                        label: data.COURSE_STREAM
                    }
                })
                setState((prevState) => ({
                    ...prevState,
                    education_qualification_list: d || [],
                    education_qualification_search_key: true
                }));
            }
        });

    }

    const getQualificationList = (e) => {
        qualificationList({ KEYWORD: e }).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        QUALIFICATION_ID: data.QUALIFICATION_ID,
                        QUALIFICATION_NAME: data.QUALIFICATION_NAME,
                        label: data.QUALIFICATION_NAME
                    }
                })
                setState((prevState) => ({
                    ...prevState,
                    qualification_list: d || [],
                    qualification_search_key: true,
                }));

            }
        });

    }
    const deleteSKills = (SKILL) => {
        let arr = state.selected_skills.filter((item) => {
            if (item.SKILL != SKILL) {
                return item;
            }
        });
        setState((prevState) => ({
            ...prevState,
            selected_skills: arr,
        }));
    };
    const getcourseSpecializationList = (list) => {
        courseSpecializationList(list).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        SPECIALIZATION_ID: data.SPECIALIZATION_ID,
                        SPECIALIZATION: data.SPECIALIZATION,
                        label: data.SPECIALIZATION
                    }
                })
                setState((prevState) => ({
                    ...prevState,
                    specialization_list: d || [],
                    specialization_search_key: true,
                }));

            }
        });

    }

    const handleSubmit = () => {
        debugger
        // if (state.selected_skills.length > 0) {
        //     onChange(this, "KEYWORDS", SELECTED_SKILLS);
        // }
        if (validateFunctionalForm(state, setState)) {
            const model = {
                WORK_EXP_MIN: state.work_exp_min.value,
                WORK_EXP_MAX: state.work_exp_max.value,
                KEYWORDS: state.selected_skills,
                JOB_DETAILS: state.job_description.value,
                INDUSTRY_ID: state.industry.value,
                QUALIFICATION_ID: state.selected_qualification.value,
                EDUCATION_QUALIFICATION_ID: state.selected_education_qualification,
                COURSE_SPECIALIZATION: state.selected_course_specialization,
                GENDER: state.gender.value,
                AGE_MIN: state.age_min.value,
                AGE_MAX: state.age_max.value,
            };
            model.JOB_ID = detail.JOB_ID;
            onSubmit(model);
        }
    };
    return (
        <React.Fragment>
            <div>
                <div className={`${styles['bgblue-ctm']} text-white`}>
                    <h5>Candidate Requirements</h5>
                    <p className="mb-0">We’ll use these requirement details to make your job visible to the right candidates.</p>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card border-0 my-3 shadow-sm'>
                            <div className='card-body p-2'>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Minimum Qualification *</label>
                                    <Multiselect
                                        placeholder='Select Qualification Type'
                                        className={state.selected_qualification.error.length > 0 ? "is-invalid" : ''}
                                        style={{
                                            optionContainer:
                                                state.qualification_search_key ? { display: 'block' } : { display: 'none' }
                                        }}
                                        options={state.qualification_list}
                                        onSelect={(selectedValue) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                ['selected_qualification']: {
                                                    ...prevState['selected_qualification'],
                                                    value: selectedValue,
                                                }
                                            }));
                                            getEducationQualificationList(selectedValue.map((item) => {
                                                return item.QUALIFICATION_ID
                                            }))

                                        }}
                                        onRemove={(selectedValue) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                ['selected_qualification']: {
                                                    ...prevState['selected_qualification'],
                                                    value: selectedValue,
                                                }
                                            }));
                                        }}

                                        onSearch={(e) => {
                                            getQualificationList(e)
                                        }
                                        }
                                        selectedValues={state.selected_qualification.value}
                                        displayValue={"QUALIFICATION_NAME"}
                                        name={state.selected_qualification.name}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Key Skills{" "}</label>
                                    <p>Specify key skills required for this job
                                        role</p>

                                    <div className="form-group">
                                        <Typeahead
                                            id="ta-skill-ids"
                                            clearButton={false}
                                            labelKey={(option) => `${option.SKILL}`}
                                            multiple={true}
                                            options={state.keywords.options}
                                            onInputChange={(value) => {
                                                searchSkill(value).then((res) => {
                                                    if (res.status) {
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            ['keywords']: {
                                                                ...prevState['keywords'],
                                                                options: res.result
                                                            }
                                                        }));
                                                    } else {
                                                        alert(res.error);
                                                    }
                                                });
                                            }}
                                            onChange={(e) => {
                                                function getUniqueListBy(arr, key) {
                                                    return [...new Map(arr.map((item) => [item[key], item])).values()];
                                                }
                                                let val = [];
                                                if (e.length > 0) {
                                                    val = e[e.length - 1];
                                                }
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    ['keywords']: {
                                                        ...prevState['keywords'],
                                                        value: val
                                                    }
                                                }));
                                                if (e[0]) {
                                                    val = state.selected_skills.concat(val);
                                                    val = val.map((item, index) => {
                                                        if (item.SKILL) {
                                                            return { SKILL: item.SKILL };
                                                        } else if (item.label) {
                                                            return { SKILL: item.label };
                                                        }
                                                    });
                                                    val = getUniqueListBy(val, "SKILL");
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        selected_skills: val
                                                    }));
                                                }

                                            }}
                                            placeholder="Add New Skill"
                                            className={
                                                state.keywords.error.length > 0
                                                    ? "errorMsg"
                                                    : ""
                                            }
                                            emptyLabel
                                        />
                                    </div>
                                    <div>
                                        {state.selected_skills.map((item) => {
                                            return (
                                                <span className="locationbox">
                                                    {item.SKILL}{" "}
                                                    <i
                                                        onClick={() => {
                                                            deleteSKills(item.SKILL);
                                                        }}
                                                        className="fa fa-close"
                                                    ></i>
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Total experience required{' '}</label>
                                    <ul className={`${styles['post-joblist']} d-flex`}>
                                        <li>
                                            <input
                                                type="radio"
                                                checked={state.work_exp_type.value === 'FRESHER'}
                                                onClick={() => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        ['work_exp_type']: {
                                                            ...prevState['work_exp_type'],
                                                            value: 'FRESHER'
                                                        },
                                                        ['work_exp_min']: {
                                                            ...prevState['work_exp_min'],
                                                            value: '0'
                                                        },
                                                        ['work_exp_max']: {
                                                            ...prevState['work_exp_max'],
                                                            value: '0'
                                                        }
                                                    }));
                                                }
                                                }
                                            />
                                            <div className="wfhheading">
                                                Fresher Only
                                                <p>This job is for fresher candidates only.</p>
                                            </div>
                                        </li>

                                        <li>
                                            <input
                                                type="radio"
                                                checked={state.work_exp_type.value === 'EXPERIENCED'}
                                                onClick={() => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        ['work_exp_type']: {
                                                            ...prevState['work_exp_type'],
                                                            value: 'EXPERIENCED'
                                                        }
                                                    }));
                                                }}
                                            />
                                            <div className="wfhheading">
                                                Experienced Only
                                                <p>This job is for experienced candidates only.</p>
                                            </div>
                                        </li>

                                        <li>
                                            <input
                                                type="radio"
                                                checked={state.work_exp_type.value === 'BOTH'}
                                                onClick={() => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        ['work_exp_type']: {
                                                            ...prevState['work_exp_type'],
                                                            value: 'BOTH'
                                                        }
                                                    }));
                                                }}
                                            />
                                            <div className="wfhheading">
                                                Fresher and Experienced Both
                                                <p>This job is open to both fresher and experienced candidates.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                {(state.work_exp_type.value == 'EXPERIENCED' || state.work_exp_type.value == 'BOTH') && (
                                    <React.Fragment>
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <input
                                                        className={
                                                            state.work_exp_min.error.length > 0
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type="number"
                                                        min="0"
                                                        placeholder="Min"
                                                        name={state.work_exp_min.name}
                                                        value={state.work_exp_min.value}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-1 text-center'>
                                                <span className="mob-span">to</span>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <input
                                                        className={
                                                            state.work_exp_max.error.length > 0
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        type="number"
                                                        min="0"
                                                        placeholder="Max"
                                                        name={state.work_exp_max.name}
                                                        value={state.work_exp_max.value}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className={`${styles['bgblue-ctm']} text-white`}>
                    <h5>Additional Detail</h5>
                    <p className="mb-0">We’ll use these requirement details to make your job visible to the right candidates.</p>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card border-0 shadow-sm rounded-3 my-3'>
                            <div className='card-body p-2'>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Industry *</label>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <select
                                                className={
                                                    state.industry.error.length > 0
                                                        ? "form-control is-invalid"
                                                        : "form-control"
                                                }
                                                name={state.industry.name}
                                                value={state.industry.value}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Industry</option>
                                                {state.industry.options.length > 0 &&
                                                    state.industry.options.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.INDUSTRY_ID}>
                                                                {item.INDUSTRY}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div className='row'>
                                        <div className='col-md-6'>

                                            <div className='col-md-12'>
                                                <label className={`${styles['ct-form-label']} form-label`}>Gender{" "}</label>
                                            </div>
                                            <select
                                                className={
                                                    state.gender.error.length > 0
                                                        ? "form-control is-invalid"
                                                        : "form-control"
                                                }
                                                name={state.gender.name}
                                                value={state.gender.value}
                                                onChange={handleChange}
                                            >
                                                <option value="BOTH">Both</option>
                                                <option value="MALE">Male</option>
                                                <option value="FEMALE">Female</option>
                                            </select>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <label className={`${styles['ct-form-label']} form-label`}>                                                                            Age
                                                        {' '}</label>
                                                </div>
                                                <div className='col-md-5'>
                                                    <NumberFormat
                                                        className={
                                                            state.age_min.error.length > 0
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        min="0"
                                                        placeholder="Min"
                                                        name={state.age_min.name}
                                                        value={state.age_min.value}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='col-md-1'>
                                                    <span className="mt-3">to</span>
                                                </div>
                                                <div className='col-md-5'>
                                                    <NumberFormat
                                                        className={
                                                            state.age_max.error.length > 0
                                                                ? "form-control is-invalid"
                                                                : "form-control"
                                                        }
                                                        min="0"
                                                        placeholder="Max"
                                                        name={state.age_max.name}
                                                        value={state.age_max.value}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>
                                        Degree{' '}</label>
                                    <Multiselect
                                        placeholder='Select Educational Qualification'
                                        style={{
                                            optionContainer:
                                                state.education_qualification_search_key ? { display: 'block' } : { display: 'none' }
                                        }}
                                        options={state.education_qualification_list}

                                        onSelect={(selectedValue) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                selected_education_qualification: selectedValue
                                            }));
                                            getcourseSpecializationList(selectedValue.map((item) => {
                                                return item.EDUCATION_QUALIFICATION_ID
                                            }))
                                        }}
                                        onRemove={(selectedValue) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                selected_education_qualification: selectedValue
                                            }));
                                        }}
                                        onSearch={(e) => {
                                            getEducationQualificationList(e)
                                        }
                                        }
                                        selectedValues={state.selected_education_qualification}
                                        displayValue={"COURSE_STREAM"}
                                        name={"EDUCATION_QUALIFICATION_ID"}
                                    />

                                </div>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>
                                        Specialization
                                    </label>
                                    <Multiselect
                                        placeholder='Select Course Specialization'
                                        style={{
                                            optionContainer:
                                                state.specialization_search_key ? { display: 'block' } : { display: 'none' }
                                        }}
                                        options={state.specialization_list}

                                        onSelect={(selectedValue) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                selected_course_specialization: selectedValue
                                            }));
                                        }}
                                        onRemove={(selectedValue) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                selected_course_specialization: selectedValue
                                            }));
                                        }}
                                        onSearch={(e) => {
                                            getcourseSpecializationList(e)
                                        }
                                        }
                                        selectedValues={state.selected_course_specialization}
                                        displayValue={"SPECIALIZATION"}
                                        name={"SPECIALIZATION_ID"}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className={`${styles['bgblue-ctm']} text-white`}>
                    <h5>Job Description</h5>
                    <p className="mb-0">Describe the responsibilities of this job and other specific requirements here.</p>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card border-0 shadow-sm rounded-3 my-3'>
                            <div className='card-body p-2'>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}> Job description / Additional requirement </label>
                                    <ReactQuill
                                        value={state.job_description.value}
                                        onChange={(content) => handleChange({ target: { name: state.job_description.name, value: content } })}
                                        className={`is-invalid ${state.job_description.error.length > 0 ? "is-invalid" : ""}`}
                                        style={{ width: "100%", padding: "10px" }}
                                    />
                                    {/* <textarea
                                        className={`form-control ${state.job_description.error.length > 0 ? "errorMsg" : ""
                                            }`}
                                        name={state.job_description.name}
                                        value={state.job_description.value}
                                        style={{ width: "100%", padding: "10px" }}
                                        onChange={handleChange}
                                        rows={7}
                                    /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-between mt-4">
                <button
                    className="btn btn-secondary"
                    onClick={prevStep}
                >
                    Previous
                </button>
                <button
                    className={`${styles['btn-next']} btn`}

                    onClick={handleSubmit}
                >
                    Next
                </button>
            </div>
        </React.Fragment>
    )
}

export default StepTwo